import React from 'react';

import { Button } from '@/slw/shared/ui/button';
import { cn } from '@/slw/shared/lib/utils';

interface ChatButtonProps {
  onClick: () => void;
  isOpen: boolean;
  count: number;
}

export const ChatButton = ({ onClick, isOpen, count }: ChatButtonProps) => {
  // Ẩn button khi chat dialog mở
  if (isOpen) return null;

  return (
    <Button
      color='light'
      onClick={onClick}
      className='fixed bottom-0 cursor-pointer right-0 z-50 bg-white  shadow-lg  border gap-0'
    >
      <img src='/images/icon/bubble-chat.svg' alt='Chat' />
      <span className='text-gray-700 font-medium text-sm ml-6'>Chat</span>
      <FloatingDotBadge count={count} />
    </Button>
  );
};

interface FloatingDotBadgeProps {
  count: number;
  className?: string;
  animate?: boolean;
  showCount?: boolean;
}

export const FloatingDotBadge = ({ count, className, animate = true, showCount = true }: FloatingDotBadgeProps) => {
  if (count === 0) return null;

  return (
    <span
      className={cn(
        'inline-flex absolute top-0 left-10 items-center justify-center rounded-full shadow-floating',
        showCount ? 'min-w-5 h-5 text-xs font-bold px-1.5 bg-destructive text-white' : 'w-3 h-3 bg-badge-primary',
        animate && 'animate-bounce-in',
        'transition-all duration-300 hover:scale-110',
        className,
      )}
    >
      {showCount && (count > 99 ? '99+' : count)}
    </span>
  );
};
